import React from 'react';
import styles from './icons.module.css';

const SortIcon = ({ isAscending = false, className = '' }) => {
  return (
    <svg 
      width="23" 
      height="23" 
      viewBox="0 0 23 23" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className={`${styles.sortIcon} ${isAscending ? styles.sortIconAscending : styles.sortIconDescending} ${className}`}
    >
      <path 
        d="M9.70689 6.62698L3.05538 13.7467C2.4336 14.4123 1.37508 14.4614 0.69102 13.8564C0.00696111 13.2514 -0.0434677 12.2214 0.578308 11.5558L10.142 1.31904C10.8061 0.607969 11.9551 0.607969 12.6192 1.31904L22.1829 11.5558C22.8047 12.2214 22.7542 13.2514 22.0702 13.8564C21.3861 14.4614 20.328 14.4123 19.7058 13.7467L13.0543 6.62698L13.0543 20.5617C13.0543 21.4611 12.305 22.1906 11.3806 22.1906C10.4563 22.1906 9.70661 21.4611 9.70661 20.5617L9.70689 6.62698Z" 
        fill="#242424"
      />
    </svg>
  );
};

export default SortIcon;
